import styled from 'styled-components';
const Wrapper = styled.div`
  position: absolute;
  height: 2px;
  background-color: #4cacb9;
  width: 100%;
  margin-bottom: 7px;
  transform-origin: 0%;
  opacity: 1;
  top: 0px;
  z-index: 1111;
`;
export { Wrapper };